import React, {
  useEffect,
  useLayoutEffect
} from "react";

import {
  useLocation
} from "react-router-dom";


const REVEAL_SELECTOR = [
  "main.category-page .category-posts-section > h1",
  "main.category-page .category-posts-section > p",
  "main.category-page .category-controls",
  "main.category-page .category-posts-grid > *",
  "main.category-page .category-sidebar > .sidebar-card",

  "main.writer-page .writer-posts-section > h1",
  "main.writer-page .writer-posts-section > p",
  "main.writer-page .writer-posts-grid > *",

  "main.public-section-landing > h1",
  "main.public-section-landing > p",
  "main.public-section-landing .article-category-grid > *"
].join(", ");


function PublicPageReveal() {

    const {
    pathname
  } = useLocation();


  // Start every newly opened route from the top.
  // useLayoutEffect prevents the previous scroll position
  // from flashing briefly before the reset.
  useLayoutEffect(() => {

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });

  }, [pathname]);


  useEffect(() => {
    const appRoot =
      document.getElementById("root");

    if (!appRoot) {
      return undefined;
    }


    const prefersReducedMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;


    const registeredElements =
      new WeakSet();

    let sequenceIndex = 0;


    const revealElement = (
      element
    ) => {

      element.classList.add(
        "public-page-reveal-visible"
      );

    };


    const intersectionObserver =
      "IntersectionObserver" in window &&
      !prefersReducedMotion
        ? new IntersectionObserver(
            (entries) => {

              entries.forEach(
                (entry) => {

                  if (
                    !entry.isIntersecting
                  ) {
                    return;
                  }

                  revealElement(
                    entry.target
                  );

                  intersectionObserver
                    .unobserve(
                      entry.target
                    );

                }
              );

            },
            {
              threshold: 0.08,

              rootMargin:
                "0px 0px -7% 0px"
            }
          )
        : null;


    const registerElement = (
      element
    ) => {

      if (
        registeredElements.has(
          element
        )
      ) {
        return;
      }

      registeredElements.add(
        element
      );

      element.classList.add(
        "public-page-reveal"
      );

      const delay =
        Math.min(
          sequenceIndex % 6,
          5
        ) * 65;

      element.style.setProperty(
        "--public-page-reveal-delay",
        `${delay}ms`
      );

      sequenceIndex += 1;


      if (
        prefersReducedMotion ||
        !intersectionObserver
      ) {

        revealElement(
          element
        );

        return;
      }


      intersectionObserver.observe(
        element
      );

    };


    const registerElementsInside = (
      scope
    ) => {

      if (
        !scope ||
        (
          scope.nodeType !==
          Node.ELEMENT_NODE &&
          scope.nodeType !==
          Node.DOCUMENT_NODE
        )
      ) {
        return;
      }


      if (
        scope.matches &&
        scope.matches(
          REVEAL_SELECTOR
        )
      ) {

        registerElement(
          scope
        );

      }


      if (
        scope.querySelectorAll
      ) {

        scope
          .querySelectorAll(
            REVEAL_SELECTOR
          )
          .forEach(
            registerElement
          );

      }

    };


    registerElementsInside(
      appRoot
    );


    const mutationObserver =
      new MutationObserver(
        (records) => {

          records.forEach(
            (record) => {

              record.addedNodes
                .forEach(
                  registerElementsInside
                );

            }
          );

        }
      );


    mutationObserver.observe(
      appRoot,
      {
        childList: true,
        subtree: true
      }
    );


    return () => {

      mutationObserver.disconnect();

      if (
        intersectionObserver
      ) {
        intersectionObserver
          .disconnect();
      }

    };

  }, [pathname]);


  return null;
}


export default PublicPageReveal;